var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseVolume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:red;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.314,4.686A16,16,0,0,0,4.686,27.314,16,16,0,0,0,27.314,4.686ZM16,30.769A14.769,14.769,0,1,1,30.769,16,14.786,14.786,0,0,1,16,30.769Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 11)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M182.337,181.472l3.9-3.9a.612.612,0,0,0-.866-.866l-3.9,3.9-3.9-3.9a.612.612,0,0,0-.866.866l3.9,3.9-3.9,3.9a.612.612,0,1,0,.866.866l3.9-3.9,3.9,3.9a.612.612,0,1,0,.866-.866Z",
    transform: "translate(-176.531 -176.532)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseVolume);
export default __webpack_public_path__ + "static/media/close-volume.b15fa0095462e27065825180037b3475.svg";
export { ForwardRef as ReactComponent };